<template>
  <div :id="`course-detail-${courseId}`">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Course Details'" />
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="2"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"
      />
      <dash-sidebar
        defaultSelectedKeys="3"
        :menuItems="commonMenuItems.admin"
        v-else-if="userRole === 'telas_telas_administrator'"
      />
      <dash-sidebar
        defaultSelectedKeys="2"
        :menuItems="commonMenuItems.assessors"
        v-else
      />
      <a-layout>
        <a-layout-content
          :style="{
            margin: '24px 16px',
            padding: '24px',
            background: '#fff',
            minHeight: '280px',
          }"
        >
          <a-card
            :title="courseDetails.title.rendered"
            :bordered="true"
            style="width: 100%"
            v-if="Object.entries(courseDetails).length > 0"
          >
            <template
              class="ant-card-actions"
              slot="actions"
              v-if="userRole === 'telas_telas_administrator'"
            >
              <!-- <a-icon type="edit" theme="twoTone" twoToneColor="#52c41a" @click="editCourseHandler"/> -->
              <a-icon
                type="delete"
                theme="twoTone"
                twoToneColor="red"
                @click="removeCourseHandler"
              />
            </template>
            <a-card title="Submission Date:" :hoverable="true" :loading="true">
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.courseSubmissionDateString[0] }}
              </div>
              <a-date-picker
                v-if="isEditing"
                slot="extra"
                format="DD/MM/YYYY"
                v-decorator="[
                  'courseSubmissionDate',
                  { rules: [{ required: true, message: 'Please select a valid Date.' }] },
                ]"
                :defaultValue="courseSubmissionDate"
                @change="handleDateChange"
              />
            </a-card>
            <a-card
              title="Course Submitter Name:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra">{{ courseDetails.post_meta.courseSubmitterName[0] }}</div>
            </a-card>
            <a-card
              title="Course Name:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.coursePackageName[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'coursePackageName',
                  {
                    rules: [{ required: true, message: 'Please enter the Course Name.' }],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.coursePackageName[0]"
                placeholder="Course Package Name"
              >
              </a-input>
            </a-card>
            <a-card
              title="Course Package Type:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.coursePackageType[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'coursePackageType',
                  {
                    rules: [{ required: true, message: 'Please enter the Course Type.' }],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.coursePackageType[0]"
                placeholder="Course Package Type"
              >
              </a-input>
            </a-card>
            <a-card
              title="Course Package Identifier:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.coursePackageIdentifier[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'coursePackageIdentifier',
                  {
                    rules: [
                      { required: true, message: 'Please enter the Course Identifier.' },
                    ],
                  },
                ]"
                placeholder="Course Package Identifier"
                :defaultValue="courseDetails.post_meta.coursePackageIdentifier[0]"
              >
              </a-input>
            </a-card>
            <a-card
              title="Course Module Identifier:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.courseModuleIdentifier[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'courseModuleIdentifier',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter the Course module identifier',
                      },
                    ],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.courseModuleIdentifier[0]"
                placeholder="Course module identifier"
              >
              </a-input>
            </a-card>
            <a-card
              title="Study Area:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.studyLevel[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'studyLevel',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter the Study Level',
                      },
                    ],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.studyLevel[0]"
                placeholder="Study Level"
              >
              </a-input>
            </a-card>
            <a-card
              title="Course Level:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.courseLevel[0] }}
              </div>
              <a-select
                placeholder="Course Level"
                style="width: 100%"
                :filterOption="false"
                slot="extra"
                v-else
                v-decorator="[
                  'courseLevel',
                  {
                    initialValue: '',
                    rules: [{ required: true, message: 'Please select one option.' }],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.courseLevel[0]"
              >
                <a-select-option value="Undergraduate">Undergraduate</a-select-option>
                <a-select-option value="Postgraduate">Postgraduate</a-select-option>
                <a-select-option value="Universal">Universal</a-select-option>
              </a-select>
            </a-card>
            <a-card
              title="Institution Name:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.institutionName[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'institutionName',
                  {
                    rules: [
                      { required: true, message: 'Please enter the Institution name' },
                    ],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.institutionName[0]"
                placeholder="Institution name"
              >
              </a-input>
            </a-card>
            <a-card
              title="Faculty/Dept:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div slot="extra" v-if="!isEditing">
                {{ courseDetails.post_meta.facultyDept[0] }}
              </div>
              <a-input
                slot="extra"
                v-else
                v-decorator="[
                  'facultyDept',
                  {
                    rules: [
                      { required: true, message: 'Please enter the Faculty / Dept' },
                    ],
                  },
                ]"
                :defaultValue="courseDetails.post_meta.facultyDept[0]"
                placeholder="Faculty / Dept"
              >
              </a-input>
            </a-card>
            <a-card
              title="Submit for Accreditation:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
            >
              <div
                slot="extra"
                v-if="courseDetails.post_meta.submitForAccreditation !== undefined"
              >
                {{ courseDetails.post_meta.submitForAccreditation[0] }}
              </div>
              <div slot="extra" v-else>Undecided</div>
            </a-card>
            <a-card
              title="Course enrollment contact:"
              :style="{ marginTop: '16px' }"
              :hoverable="true"
              :loading="true"
              v-if="courseDetails.post_meta.enrollerName !== undefined"
            >
              <span
                slot="extra"
                v-if="courseDetails.post_meta.enrollerName !== undefined"
                style="margin-right: 10px"
                ><a-icon type="user" theme="outlined" />
                {{ courseDetails.post_meta.enrollerName[0] }}</span
              >
              <span
                slot="extra"
                v-if="courseDetails.post_meta.enrollerEmail !== undefined"
                style="margin-right: 10px"
                ><a-icon type="ie-circle" theme="filled" />
                {{ courseDetails.post_meta.enrollerEmail[0] }}</span
              >
              <span
                slot="extra"
                v-if="courseDetails.post_meta.enrollerPhone !== undefined"
                style="margin-right: 10px"
                ><a-icon type="phone" theme="filled" />
                {{ courseDetails.post_meta.enrollerPhone[0] }}</span
              >
            </a-card>

            <a-card title="Assessment Framework:" :style="{ marginTop: '16px' }">
              <span slot="extra">
                <a-radio-group
                  button-style="solid"
                  :key="radioGroupKey"
                  :value="selectedFrameworkId"
                  @change="handleFrameworkChange($event)"
                >
                  <a-radio-button
                    v-for="framework in frameworksList"
                    :key="framework.id"
                    :value="framework.id"
                  >
                    {{ framework.title.rendered }}
                  </a-radio-button>
                </a-radio-group>
              </span>
            </a-card>
          </a-card>
          <a-card
            :style="{ marginTop: '16px' }"
            v-if="
              userDetails.user_role === 'telas_telas_administrator' &&
              courseDetails.status === 'draft'
            "
          >
            <a-button
              id="approve-course-button"
              type="default"
              icon="check"
              @click="handlePostStatusChange('publish')"
            >
              Approve
            </a-button>
            <a-button
              id="decline-course-button"
              type="danger"
              icon="cross"
              @click="handlePostStatusChange('draft')"
            >
              Decline
            </a-button>
          </a-card>
          <a-card
            title="Reviewer Status"
            :style="{ marginTop: '16px' }"
            v-if="userRole === 'telas_telas_administrator'"
          >
            <a-col
              defaultActiveKey="1"
              accordion
              v-if="
                courseDetails.post_meta !== undefined &&
                courseDetails.post_meta.forTest !== undefined &&
                courseDetails.post_meta.forTest[0] === 'no'
              "
            >
              <a-row :gutter="10">
                <assign-reviewer
                  :courseDetails="courseDetails"
                  :userToken="userToken"
                  :successMessage="successMessage"
                  :reviewerLevel="'telas_admin_reviewers'"
                />
                <assign-reviewer
                  :courseDetails="courseDetails"
                  :userToken="userToken"
                  :successMessage="successMessage"
                  :reviewerLevel="'first_reviewer'"
                />
                <assign-reviewer
                  :courseDetails="courseDetails"
                  :userToken="userToken"
                  :successMessage="successMessage"
                  :reviewerLevel="'second_reviewer'"
                />
                <a-col
                  :span="12"
                  v-for="(reportDetail, index) in combinedReviewsDetails"
                  :key="`report-${index}`"
                  class="reviewers-section"
                >
                  <a-card :style="{ marginTop: '16px' }" title="Combined Review">
                    <template #extra>
                      <div class="assessment-status">
                        <a-tag
                          :color="
                            reportDetail.report_details.assessment_status === 'assigned'
                              ? 'red'
                              : reportDetail.report_details.assessment_status ===
                                'in-progress'
                              ? 'cyan'
                              : reportDetail.report_details.assessment_status ===
                                'completed'
                              ? 'green'
                              : reportDetail.report_details.assessment_status ===
                                'complete'
                              ? 'green'
                              : 'orange'
                          "
                        >
                          <router-link
                            :to="{
                              name: 'report-detail',
                              params: { reportId: reportDetail.id },
                            }"
                          >
                            {{
                              capitalize(reportDetail.report_details.assessment_status)
                            }}
                          </router-link>
                        </a-tag>
                      </div>
                    </template>
                    <div class="commencement-date">
                      <label> Commencement Date:</label>
                      <span v-if="reportDetail.report_details.commencement_date !== ''">{{
                        reportDetail.report_details.commencement_date | formatDate
                      }}</span>
                      <span v-else>---</span>
                    </div>
                    <div class="completion-date">
                      <label>Completion Date:</label>
                      <span v-if="reportDetail.report_details.completion_date !== ''">{{
                        reportDetail.report_details.completion_date | formatDate
                      }}</span>
                      <span v-else>---</span>
                    </div>
                  </a-card>
                  <a-card
                    :style="{ marginTop: '16px' }"
                    :title="`Submit for Re-assessment`"
                    v-if="
                      !isSubmittedForReassessment &&
                      combinedReviewsDetails.length > 0 &&
                      combinedReviewsDetails[0].report_details.assessment_status ===
                        'complete'
                    "
                  >
                    <template #extra>
                      <div class="assessment-status">
                        <a-tag :color="'gray'">Not Started</a-tag>
                      </div>
                    </template>
                    <a-popconfirm
                      placement="top"
                      ok-text="Ready"
                      cancel-text="Cancel"
                      @confirm="handleReassessment()"
                      okType="danger"
                    >
                      <template slot="title">
                        <h3>Ready for re-assessment?</h3>
                        <p>
                          By clicking 'Ready' you confirm that you made the neccessary
                          changes to your course<br />
                          and it is now ready to be re-assessed.
                        </p>
                      </template>
                      <div style="text-align: center">
                        <a-button
                          type="primary"
                          v-if="
                            combinedReviewsDetails[0].report_details.assessment_status ===
                            'complete'
                          "
                          v-show="
                            combinedReviewsDetails[0].report_details.assessment_status ===
                            'complete'
                          "
                          style="margin: 0 auto"
                        >
                          Ready for Re-assessment
                        </a-button>
                      </div>
                    </a-popconfirm>
                  </a-card>
                </a-col>
                <a-col
                  :span="12"
                  v-for="(reassessmentDetail, index) in reassessmentDetails"
                  :key="`reassessment-${index}`"
                  class="reviewers-section"
                >
                  <a-card :style="{ marginTop: '16px' }" title="Reassessment Review">
                    <template #extra>
                      <div class="assessment-status">
                        <a-tag
                          :color="
                            reassessmentDetail.report_details.assessment_status ===
                            'assigned'
                              ? 'red'
                              : reassessmentDetail.report_details.assessment_status ===
                                'in-progress'
                              ? 'cyan'
                              : reassessmentDetail.report_details.assessment_status ===
                                'completed'
                              ? 'green'
                              : reassessmentDetail.report_details.assessment_status ===
                                'complete'
                              ? 'green'
                              : 'orange'
                          "
                        >
                          <router-link
                            :to="{
                              name: 'report-detail',
                              params: { reportId: reassessmentDetail.id },
                            }"
                          >
                            {{
                              capitalize(
                                reassessmentDetail.report_details.assessment_status
                              )
                            }}
                          </router-link>
                        </a-tag>
                      </div>
                    </template>
                    <div class="commencement-date">
                      <label> Commencement Date:</label>
                      <span
                        v-if="reassessmentDetail.report_details.commencement_date !== ''"
                        >{{
                          reassessmentDetail.report_details.commencement_date | formatDate
                        }}</span
                      >
                      <span v-else>---</span>
                    </div>
                    <div class="completion-date">
                      <label>Completion Date:</label>
                      <span
                        v-if="reassessmentDetail.report_details.completion_date !== ''"
                        >{{
                          reassessmentDetail.report_details.completion_date | formatDate
                        }}</span
                      >
                      <span v-else>---</span>
                    </div>
                  </a-card>
                </a-col>
                <!-- Combined Reviewer -->
              </a-row>
            </a-col>
            <a-row
              :gutter="10"
              v-if="
                userDetails.user_role === 'telas_telas_administrator' &&
                courseDetails.status === 'publish' &&
                courseDetails.post_meta !== undefined &&
                courseDetails.post_meta.forTest !== undefined &&
                courseDetails.post_meta.forTest[0] !== 'no'
              "
              key="1"
              style="padding-bottom: 16px"
            >
              <assign-reviewer
                :courseDetails="courseDetails"
                :userToken="userToken"
                :successMessage="successMessage"
                :reviewerLevel="'telas_admin_reviewers'"
              />
              <assign-interim-reviewer
                :courseDetails="courseDetails"
                :userToken="userToken"
                :successMessage="successMessage"
                :reviewerLevel="'telas_interim_reviewer'"
              />
            </a-row>
          </a-card>
          <a-row
            :style="{ marginTop: '16px' }"
            :gutter="10"
            v-if="
              userDetails.user_role === 'telas_telas_administrator' &&
              courseDetails.status === 'publish' &&
              courseDetails.post_meta !== undefined &&
              courseDetails.post_meta.forTest !== undefined &&
              courseDetails.post_meta.forTest[0] !== 'no'
            "
            header="Assigned Interim Reviewers"
            key="2"
          >
            <assigned-interim-reviewers-list :courseDetails="courseDetails" />
          </a-row>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
import dashSidebar from "./Sidebar.vue";
import dashHeader from "./Header.vue";
import assignReviewer from "./admin/Assign-reviewer.vue";
import assignInterimReviewer from "./admin/Assign-interim-reviewer.vue";
import assignedInterimReviewersList from "./admin/Assigned-interim-reviewers-list.vue";
import { Modal } from "ant-design-vue";

export default {
  name: "course-details",
  components: {
    dashSidebar,
    dashHeader,
    assignReviewer,
    assignInterimReviewer,
    assignedInterimReviewersList,
  },
  data() {
    this.interimLastFetchId = 0;
    this.firstReviewerLastFetchId = 0;
    this.secondReviewerLastFetchId = 0;
    return {
      selectedFrameworkId: "",
      radioGroupKey: 0,
      courseId: "",
      combinedReviewsDetails: [],
      reassessmentDetails: [],
      breadCrumbsPages: [
        {
          name: "Home",
          route: "/",
        },
        {
          name: "Dashboard",
          route: "/dashboard",
        },
        {
          name: "Course Details",
          route: `/course/${this.$route.params.courseId}`,
        },
      ],
      dashboardTitle: "",
      reviewerLevel: "",
      assignedAssessments: "",
      courseSubmissionDate: "",
      isEditing: false,
    };
  },
  computed: {
    ...mapState("courses", {
      courseDetails: (state) => state.courseDetails,
    }),
    ...mapState("user", {
      userDetails: (state) => state.userDetails,
    }),
    ...mapGetters("user", {
      userToken: "getUserToken",
      userRole: "getUserRole",
    }),
    ...mapState("dashboard", {
      userAssignedCourses: (state) => state.courses.assessorsCourses.assigned,
      allCourses: (state) => state.courses.allCourses,
    }),
    ...mapState("courses", {
      assessmentData: (state) => state.courseDetails.assesment_data,
    }),
    ...mapState("reports", {
      reportData: (state) => state.reportDetails,
    }),
    ...mapGetters("common", {
      successMessage: "commonSuccess",
    }),
    ...mapState("frameworks", {
      // Directly use the state from the frameworks module
      frameworksList: (state) => state.frameworks,
    }),
    isSubmittedForReassessment() {
      return (
        this.courseDetails.post_meta &&
        this.courseDetails.post_meta.reassessment_report_id
      );
    },
  },
  mounted() {
    this.courseId = this.$route.params.courseId;
    this.dashboardTitle = this.userDetails.user_role;
    this.getCourseById({ courseId: this.courseId, userToken: this.userToken });
    this.fetchFrameworks(); // Dispatch the action to fetch frameworks
    if (
      this.courseDetails &&
      this.courseDetails.acf &&
      this.courseDetails.acf.framework
    ) {
      this.selectedFrameworkId = this.courseDetails.acf.framework;
    }
  },
  watch: {
    "courseDetails.acf.framework"(newVal) {
      this.selectedFrameworkId = newVal;
    },
    frameworksList(newList) {
      if (newList && newList.length > 0) {
        // The list is now populated, do something if needed
      }
    },
    courseDetails(newValue, oldValue) {
      if (newValue && Object.keys(newValue).length !== 0) {
        this.fetchReportDetails();
        this.fetchReassessmentReportDetails();
      }
    },
    userToken() {
      this.getCourseById({ courseId: this.courseId, userToken: this.userToken });
    },
    successMessage(newValue) {
      if (newValue === "Deleted") {
        setTimeout(() => {
          this.$message.success(newValue, 1, this.clearSuccessMessage);
          this.$router.push({ name: "dashboard" });
        }, 2000);
      }
      if (newValue.length > 0 && newValue !== "Deleted") {
        this.$message.success(newValue, 3, this.clearSuccessMessage);
      }
    },
  },
  created() {},
  methods: {
    capitalize(str) {
      if (!str || typeof str !== "string") return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    ...mapActions("courses", {
      getCourseById: "getCourseById",
      changePostStatus: "changePostStatus",
      createAssessment: "createAssessment",
      updateCourseFramework: "updateCourseFramework",
      deleteCourse: "deleteCourse",
    }),
    ...mapActions("assessments", {
      getReportById: "getReportById",
    }),
    ...mapActions("frameworks", {
      fetchFrameworks: "fetchFrameworks",
      fetchFrameworkById: "fetchFrameworkById",
    }),
    async handleFrameworkChange(event) {
      const originalFrameworkId = this.courseDetails.acf.framework;
      const newFrameworkId = event.target.value;
      Modal.confirm({
        title:
          "Are you sure you would like to change the Questionnaire Framework for this course?",
        content:
          "If you already have existing assessments that are either in progress or completed, changing the framework will make the data in them unreadable. Are you sure you want to proceed?",
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        icon: "warning",
        onOk: () => {
          // User confirmed, proceed with the framework update
          this.selectedFrameworkId = newFrameworkId;
          this.updateCourseFramework({
            courseId: this.courseId,
            frameworkId: newFrameworkId,
            userToken: this.userToken,
          });
        },
        onCancel: () => {
          // Force re-render of the radio group by updating its key
          this.radioGroupKey += 1;
          this.$nextTick(() => {
            this.selectedFrameworkId = originalFrameworkId;
          });
        },
      });
    },
    async fetchReassessmentReportDetails() {
      if (
        this.courseDetails &&
        this.courseDetails.post_meta &&
        this.courseDetails.post_meta.reassessment_report_id
      ) {
        //console.log('Fetching report details', this.courseDetails.post_meta.report_post_id);
        const reassessmentReportId = this.courseDetails.post_meta.reassessment_report_id; // Ensure this is the correct path to your IDs
        try {
          await this.getReportById({
            reportId: reassessmentReportId,
            userToken: this.userToken, // Ensure you have `userToken` available in your component
          }).then((data) => {
            this.reassessmentDetails.push(data);
            //console.log('Report fetched', data);
          });
        } catch (error) {
          console.error("Failed to fetch report details", error);
          // Optionally implement retry logic here
        }
      } else {
        // If courseDetails is not ready, you might want to retry after some delay
        setTimeout(this.fetchReassessmentReportDetails, 1000); // Retry after 1 second
      }
    },
    async fetchReportDetails() {
      if (
        this.courseDetails &&
        this.courseDetails.post_meta &&
        this.courseDetails.post_meta.report_post_id
      ) {
        //console.log('Fetching report details', this.courseDetails.post_meta.report_post_id);
        const reportIds = this.courseDetails.post_meta.report_post_id; // Ensure this is the correct path to your IDs
        try {
          for (let reportId of reportIds) {
            //console.log(reportId);
            await this.getReportById({
              reportId: reportId,
              userToken: this.userToken, // Ensure you have `userToken` available in your component
            }).then((data) => {
              this.combinedReviewsDetails.push(data);
              //console.log('Report fetched', data);
            });
          } //console.log(this.combinedReviewsDetails);
        } catch (error) {
          console.error("Failed to fetch report details", error);
          // Optionally implement retry logic here
        }
      } else {
        // If courseDetails is not ready, you might want to retry after some delay
        setTimeout(this.fetchReportDetails, 1000); // Retry after 1 second
      }
    },
    ...mapActions("reports", {
      initiateReassessment: "initiateReassessment",
    }),
    async handleReassessment() {
      if (this.courseDetails.post_meta.report_post_id[0]) {
        console.log(this.courseDetails.post_meta.report_post_id[0]);
        const reportId = this.courseDetails.post_meta.report_post_id[0]; // Ensure this is the correct path to your IDs
        try {
          //console.log(reportId);
          await this.initiateReassessment(reportId).then((data) => {
            location.reload();
            console.log("Report cloned", data);
          });
        } catch (error) {
          //console.log(this.combinedReviewsDetails);
          console.error("Failed to clone report", error);
          // Optionally implement retry logic here
        }
      }
    },
    ...mapActions("common", {
      clearSuccessMessage: "clearSuccessMessage",
    }),
    handlePostStatusChange(postStatus) {
      this.changePostStatus({
        courseId: this.courseId,
        status: postStatus,
        userToken: this.userToken,
      });
    },
    editCourseHandler() {
      // this.isEditing ^= true;
      this.courseSubmissionDate = moment(
        this.courseDetails.post_meta.courseSubmissionDateString[0],
        "DD/MM/YYYY"
      );
    },
    removeCourseHandler() {
      this.deleteCourse({
        courseId: this.courseId,
        userToken: this.userToken,
      });
    },
    handleDateChange(date, dateString) {
      this.courseSubmissionDate = dateString;
    },
  },
  mutations: {
    REPORTFETCHED(state, { actualData, rootState }) {
      // Handle the fetched report data. For example, you might add it to the state:
      state.fetchedReports.push(actualData);
      console.log("Fetched report data:", actualData);
      // Adjust above line as needed based on how you've structured your state
    },
  },
};
</script>
<style scoped>
#approve-course-button:hover {
  border-color: #73d13d;
  background-color: #73d13d;
  color: #ffff;
}
#approve-course-button {
  color: #73d13d;
  float: right;
}
#decline-course-button {
  float: left;
}
</style>
<style>
.reviewers-section label {
  width: 50%;
  display: inline-block;
  margin-top: 5px;
}
.ant-tag a {
  color: inherit;
}
.ant-tag a:hover {
  color: inherit;
}
.ant-tag:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
</style>
